/**
 * Created by Dhanya Akhil on 1/30/2017.
 */
import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LocalStorageService} from 'ngx-webstorage';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {RouterModule, Routes} from '@angular/router';
import {routing} from './app-routing.module';
import {NavbarModule} from './components/navbar/navbar.module';
import {AppComponent} from './app.component';

import {LoginModule} from './components/login/login.module';
import {HomeModule} from './components/home/home.module';
import {BalanceModule} from './components/balance/balance.module';
import {ContactModule} from './components/contact/contact.module';
import {FaqModule} from './components/faq/faq.module';
import {PasswordModule} from './components/password/password.module';
import {DocumentModule} from './components/document/document.module';
import {ForgotPasswordModule} from './components/forgot-password/forgot-password.module';
import {FundperformanceModule} from './components/fundperformance/fundperformance.module';
import {UnitpriceModule} from './components/unitprice/unitprice.module';
import {FundadminModule} from './components/fundadmin/fundadmin.module';
import {EmployeeActivateModule} from './components/employee-activate/employee-activate.module';
import {UserlockModule} from './components/userlock/userlock.module';
import {SendForgotPasswordModule} from './components/send-forgotpassword/send-forgotpassword.module';
import {SendWelcomeMailModule} from './components/send-welcomemail/send-welcomemail.module';
import {SupportModule} from './components/support/support.module';
import {AuthServerProvider, LoginService, PrincipalService, WindowRef} from './shared';
import {HttpLoaderFactory} from './http-loader-factory';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {CustomHttpInterceptor} from './custom-http-interceptor';
import {AccountResourceService} from './shared/services/account-resource.service';
import {PersonalInformationModule} from './components/personal-information/personal-information.module';
// import {PensionCalculatorModule} from "./components/pension-calculator/pension-calculator.module";
import {CalculatorModule} from './components/pension-calculator/calculator.module';
import {MaintenanceModule} from './components/maintenance/maintenance.module';
import {FundSwitchingModule} from './components/fund-switching/fund-switching.module';
import {PaginationModule} from 'ngx-bootstrap/pagination';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {PopoverModule} from 'ngx-bootstrap/popover';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AngularMyDatePickerModule} from 'angular-mydatepicker';
import {HeaderComponent} from './shared/components/header/header.component';
import {FooterComponent} from './shared/components/footer/footer.component';
import {MenuTranslationComponent} from './shared/components/header/menu/menu-translation/menu-translation.component';
import {MenuTimeoutComponent} from './shared/components/header/menu/menu-timeout/menu-timeout.component';
import {MenuProfileComponent} from './shared/components/header/menu/menu-profile/menu-profile.component';
import {MenuDesktopComponent} from './shared/components/header/menu/menu-desktop/menu-desktop.component';
import {AccountResourceApi} from './shared/services/api/account-resource.api';

import {BulkUploadModule} from './components/bulk-upload-onboarding-member/bulk-upload.module';
import {BsModalModule} from 'ng2-bs3-modal';

import {AllianzLogoComponent} from './shared/components/allianz-logo/allianz-logo.component';
import {MenuMobileComponent} from './shared/components/header/menu/menu-mobile/menu-mobile.component';

import {RiskProfileModule} from './components/risk-profile/risk-profile.module';
import {TokenService} from './shared/services/token.service';
// import {MatStepperModule} from '@angular/material/stepper';
// import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field';
const routes: Routes = [];

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    MenuDesktopComponent,
    MenuMobileComponent,
    MenuProfileComponent,
    MenuTimeoutComponent,
    MenuTranslationComponent,
    AllianzLogoComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BsModalModule,
    NavbarModule,
    LoginModule,
    HomeModule,
    BalanceModule,
    ContactModule,
    FaqModule,
    PasswordModule,
    DocumentModule,
    ForgotPasswordModule,
    FundperformanceModule,
    UnitpriceModule,
    FundadminModule,
    EmployeeActivateModule,
    UserlockModule,
    RiskProfileModule,
    SendForgotPasswordModule,
    SendWelcomeMailModule,
    SupportModule,
    PersonalInformationModule,
    // MatStepperModule,
    // PensionCalculatorModule,
    CalculatorModule,
    MaintenanceModule,
    FundSwitchingModule,
    BulkUploadModule,
    routing,
    RouterModule.forRoot(routes, {useHash: true, relativeLinkResolution: 'legacy'}),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      isolate: false
    }),
    PaginationModule.forRoot(),
    TooltipModule.forRoot(),
    PopoverModule.forRoot(),
    BrowserAnimationsModule,
    AngularMyDatePickerModule
  ],
  providers: [
    PrincipalService,
    AccountResourceService,
    AccountResourceApi,
    AuthServerProvider,
    LoginService,
    TokenService,
    LocalStorageService,
    WindowRef,
    // {provide: XHRBackend, useClass: customXHRBackend}
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomHttpInterceptor,
      multi: true,
    },
    // {
    //   provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
    //   useValue: { appearance: 'fill' }
    // }
  ],
  bootstrap: [AppComponent]
})

export class AppModule {}
